import axios from 'axios';

export class HttpClient {
  private baseURL: string;

  constructor(baseURL: string) {
    this.baseURL = baseURL;
  }

  async get<T>(endpoint: string): Promise<T> {
    try {
      const response = await axios.get<T>(`${this.baseURL}${endpoint}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(`GET ${endpoint}: ${error.message}`);
      }
      throw new Error(`GET ${endpoint}: Unknown error occurred`);
    }
  }

  async post<T>(endpoint: string, data?: any): Promise<T> {
    try {
      const response = await axios.post<T>(`${this.baseURL}${endpoint}`, data);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(`POST ${endpoint}: ${error.message}`);
      }
      throw new Error(`POST ${endpoint}: Unknown error occurred`);
    }
  }
}
